<ng-template #consentSnackBar>
    <div>
        {{message}}
    </div>
    <div class="actions">
        <button mat-flat-button (click)="goToPrivacy()">{{readMore}}</button>
        <button mat-flat-button color="primary" (click)="giveConsent()">{{dismiss}}</button>
    </div>
</ng-template>